import React from "react";
import { motion, AnimatePresence } from "framer-motion";

// Loading-screen logo lives in the public folder, so reference it by URL
// (public assets are not imported like src assets in CRA).
const logo = `${process.env.PUBLIC_URL}/logo2.png`;

export default function Loader({ loading }) {
  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          className="screen-loader"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.9, ease: "easeInOut" } }}
        >
          <motion.img
            src={logo}
            alt="logo"
            className="pulse-logo"
            initial={{ scale: 0.9, opacity: 0, rotate: -10 }}
            animate={{ 
              scale: [0.9, 1.1, 1], 
              opacity: 1, 
              rotate: 0 
            }}
            transition={{ 
              duration: 0.9, 
              ease: "backOut",
              scale: { type: "spring", stiffness: 200 }
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
